import { Link } from "@tanstack/react-router";
import {
  Carousel,
  CarouselContent,
  CarouselIndicator,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";
import { RichTextRenderer } from "~/components/RichTextRenderer";
import { withLocale } from "~/lib/utils/with-locale";

export const CardSliderInset = ({
  title,
  description,
  items,
}: {
  title: string;
  description: string;
  items: React.ReactNode[];
}) => {
  return (
    <Carousel>
      <div className="bg-white flex flex-col lg:flex-row gap-10 p-8 rounded-md">
        <div className="max-w-[350px] shrink-0">
          <h2 className="font-medium text-5xl">{title}</h2>
          <RichTextRenderer additionalClasses="mt-6" richText={description} />
        </div>
        <CarouselContent className="pr-8">
          {items.map((item, index) => {
            return (
              <CarouselItem
                key={index}
                className="basis-full md:basis-1/3 xl:basis-1/4 pl-0 mr-8 last:mr-0"
              >
                {item}
              </CarouselItem>
            );
          })}
        </CarouselContent>
      </div>
      <div className="mt-12 flex items-center justify-between w-full">
        <CarouselIndicator variant="gray" alignment="left" size="small" />
        <div className="flex gap-4">
          <CarouselPrevious className="static m-0 translate-y-0 rounded-sm" />
          <CarouselNext className="static m-0 translate-y-0 rounded-sm" />
        </div>
      </div>
    </Carousel>
  );
};

function isExternalLink(link: string) {
  return (
    link.startsWith("http://") ||
    link.startsWith("https://") ||
    link.startsWith("mailto:") ||
    link.startsWith("tel:")
  );
}

export const TeaserCardInset = ({
  title,
  image,
  link,
}: {
  title: string;
  image: string;
  link: string;
}) => {
  const to = link && !isExternalLink(link) ? withLocale(link) : link || withLocale("/");
  return (
    <Link
      to={to}
      className="flex flex-col relative rounded-md overflow-hidden"
    >
      <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/10 to-transparent"></div>
      <img
        src={image}
        alt=""
        className="w-full h-full object-cover aspect-250/300"
      />
      <div className="absolute inset-0 bg-black/25">
        <h3 className="text-2xl font-semibold absolute z-0 text-white right-5 bottom-4">
          {title}
        </h3>
      </div>
    </Link>
  );
};
